(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.announcementHeight = this.header.closest('body')?.querySelector('.announcement-bar-section .scroll-wrapper')?.offsetHeight || 0;
      this.header.style.setProperty('--header-top', `${this.announcementHeight}px`);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      
      if (this.announcementHeight != 0) {
        document.querySelector('.announcement-bar-section').classList.remove('sticky-anouncement', 'animate');
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.announcementHeight != 0) {
        document.querySelector('.announcement-bar-section').classList.add('sticky-anouncement', 'animate');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-look"] && !window.DesignMode) return;
  try {
    
    if (!customElements.get('popup-opener')) {
        customElements.define('popup-opener',
            class PopupOpener extends HTMLElement {
                constructor() {
                    super();
                    
                    this.buttonModal = this.querySelector('[data-button-modal]');
                    this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
                    this.buttonModal.addEventListener('click', this.onButtonModalClick.bind(this));

                    if (this.querySelector('[data-button-close]')) this.querySelector('[data-button-close]').addEventListener('click', this.close.bind(this));

                    this.buttonModal.setAttribute('role', 'button');
                }

                isOpen() {
                    return this.hasAttribute('open');
                }

                onButtonModalClick(event) {
                    event.preventDefault();
                    event.target.closest('popup-opener').hasAttribute('open') ? this.close() : this.open(event);
                }

                onBodyClick(event) {
                    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
                }

                open(event) {
                    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
                    event.target.closest('popup-opener').setAttribute('open', true);
                    document.body.addEventListener('click', this.onBodyClickEvent);

                    if (window.outerWidth < 990) document.body.classList.add('body-overflow-hidden');
                }

                close(focusToggle = true) {
                    removeTrapFocus(focusToggle ? this.buttonModal : null);
                    this.removeAttribute('open');
                    document.body.removeEventListener('click', this.onBodyClickEvent);
                    if (window.outerWidth < 990) document.body.classList.remove('body-overflow-hidden');
                }
            }
        )
    }

    function onResize() {
        if (window.outerWidth < 990) document.body.classList.add('body-overflow-hidden');
    }

  } catch(e) { console.error(e); }
})();
})();
